import React from 'react'
import LoadAsset from '../pages/DesignAssets/LoadAsset'
import LoadCB from '../pages/DesignAssets/LoadCB';

const LoadConfigDetailsModal = (props) => {
   const loadData = {...props};
  return (
    <se-dialog
    id="dialog-complex"
    size="large"
    open={loadData?.isOpenLoadConfig}
    can-backdrop="false"
    style = {{visibility:`${loadData?.assetInfo?.assetSelected?"hidden":"visible"}`}}
  >
    <se-dialog-header> Configure Load</se-dialog-header>

    <se-dialog-content className="se-dialog-content">
      { loadData &&  <LoadAsset loadData ={loadData}/>}
      {loadData && loadData?.CBLoadList[loadData?.selectedValues?.selectedLoad]?.uiData?.cbRequired &&  <LoadCB loadData ={loadData}/>}
    </se-dialog-content>
    <se-dialog-footer>
      <se-button onClick={()=>loadData?.setIsOpenLoadConfig(false)}>Close</se-button>
    </se-dialog-footer>
  </se-dialog>
  )
}

export default LoadConfigDetailsModal